import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LookupCategoryAddComponent, LookupCategorySearchComponent, 
  LookupMasterAddComponent, LookupMasterSearchComponent,
CountrySearchComponent, StateSearchComponent, CitySearchComponent, EmailTemplateSearchComponent,
ClaimsMasterSearchComponent, ApplicationFeaturesSearchComponent, ApplicationClaimTypesSearchComponent,
UserClaimsComponent, UserRoleDefaultFeaturesComponent,UserapprovalSearchComponent,EmailTemplateAddComponent,EmailTemplateViewComponent,
 CompanyApprovalSearchComponent, CompanyApprovalViewComponent, ClientMasterComponent
, VendorClientAssignmentComponent, ClientRequisitionContactComponent, ClientCheckListsComponent,ClientApprovalSearchComponent, SearchPageThemeComponent, SearchPageColumnsComponent, SearchThemecolumnsAssignComponent, SearchThemeusersAssignComponent, DvmsSystemAlertsComponent,EmailChannelComponent} from './components';
import { EmailConfigurationComponent } from './components/email-configuration/email-configuration.component';
import { SendEmailComponent } from './components/send-email/send-email.component';
import { ImportInvoiceApplicantComponent } from './components/import-invoice-applicant/import-invoice-applicant.component';
import { CreateVendorComponent } from './components/create-vendor/create-vendor.component';
import { VendorProfileStatusComponent } from './components/vendor-profile-status/vendor-profile-status.component';
import { RateChangeRequestComponent } from './components/rate-change-request/rate-change-request.component';
import { DocumentTemplateAddComponent } from './components/document-template/document-template-add/document-template-add.component';
import { DocumentTemplateSearchComponent } from './components/document-template/document-template-search/document-template-search.component';
import { DocumentTemplateViewComponent } from './components/document-template/document-template-view/document-template-view.component';
import { VendorOnboardingComponent } from './components/vendor-onboarding/vendor-onboarding.component';
import { VendorOnboardProcessSearchComponent } from './components/vendor-onboard-process-search/vendor-onboard-process-search.component';
import { VendorOnboardApprovalViewComponent } from './components/vendor-onboard-approval-view/vendor-onboard-approval-view.component';
import { VendorOnboardApprovalSearchComponent } from './components/vendor-onboard-approval-search/vendor-onboard-approval-search.component';

  export const routes: Routes = [
    { path: '', component: LookupCategorySearchComponent },
    { path: 'lookup-category', component: LookupCategorySearchComponent },
    { path: 'lookup-master', component: LookupMasterSearchComponent },
    { path: 'country', component: CountrySearchComponent },
    { path: 'state', component: StateSearchComponent },
    { path: 'city', component: CitySearchComponent },
    { path: 'email-template', component:EmailTemplateSearchComponent},
    { path: 'document-template', component:DocumentTemplateSearchComponent},
    { path: 'claims-master', component: ClaimsMasterSearchComponent },
    { path: 'application-features', component: ApplicationFeaturesSearchComponent },
    { path: 'application-claim-types', component: ApplicationClaimTypesSearchComponent },
    { path: 'user-claims', component: UserClaimsComponent },
    { path: 'user-role-default-features', component: UserRoleDefaultFeaturesComponent },
    { path: 'userapproval-search', component: UserapprovalSearchComponent },
    { path: 'email-template-add', component:EmailTemplateAddComponent},
    { path: 'document-template-add', component:DocumentTemplateAddComponent},
     {path: 'email-template-add/:id', component: EmailTemplateAddComponent},
     {path: 'document-template-add/:id', component: DocumentTemplateAddComponent},
     {path: 'vendor-approval-search', component: CompanyApprovalSearchComponent},
     {path: 'vendor-approval-view', component: CompanyApprovalViewComponent},
     {path: 'email-template-view', component: EmailTemplateViewComponent},
     {path: 'document-template-view', component: DocumentTemplateViewComponent},
     {path: 'client-master', component: ClientMasterComponent},
     {path: 'vendor-client-assignment', component: VendorClientAssignmentComponent}, 
     {path: 'client-requisition-contact', component: ClientRequisitionContactComponent},
     {path: 'email-configuration', component: EmailConfigurationComponent},
     {path: 'client-checklist', component: ClientCheckListsComponent},
     {path: 'send-email', component: SendEmailComponent},
     {path: 'client-approval-search', component: ClientApprovalSearchComponent},
     {path: 'import-invoice-applicant', component: ImportInvoiceApplicantComponent},
     {path: 'create-vendor', component: CreateVendorComponent},
     {path: 'vendor-profile-status', component: VendorProfileStatusComponent},
     {path: 'search-page-theme', component: SearchPageThemeComponent},
     {path: 'search-page-columns', component: SearchPageColumnsComponent},
     {path: 'search-themecolumns-assign', component: SearchThemecolumnsAssignComponent},
     {path: 'search-themeusers-assign', component: SearchThemeusersAssignComponent},
     {path: 'rate-change-request', component: RateChangeRequestComponent},
     {path: 'dvms-system-alerts', component: DvmsSystemAlertsComponent},
     {path: 'email-channel', component: EmailChannelComponent},
     {path: 'vendor-onboarding', component: VendorOnboardingComponent},
     {path: 'vendor-onboard-process-search', component: VendorOnboardProcessSearchComponent},
     {path: 'vendor-onboard-approval-view', component: VendorOnboardApprovalViewComponent},
     {path: 'vendor-onboard-approval-search', component: VendorOnboardApprovalSearchComponent},

  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
